import { api } from './api'
import { throwApiError } from './apiHelpers'

function assertSuccess(body) {
  if (!body?.success) {
    const err = new Error(body?.message || 'Request failed')
    err.code = body?.error?.code
    throw err
  }
  return body.data
}

/** super_admin — enable/disable POS for a store */
export async function patchStorePosSettings(storeId, posEnabled) {
  try {
    const { data } = await api.patch(`/admin/stores/${encodeURIComponent(storeId)}/pos-settings`, {
      posEnabled,
    })
    return assertSuccess(data)
  } catch (e) {
    throwApiError(e, 'Could not update POS setting')
  }
}

/** super_admin — cash vs transfer totals per staff */
export async function getPosRemittanceByStaff(storeId, from, to) {
  try {
    const { data } = await api.get(
      `/admin/stores/${encodeURIComponent(storeId)}/pos/remittance-by-staff`,
      { params: { from, to } },
    )
    return assertSuccess(data)
  } catch (e) {
    throwApiError(e, 'Failed to load remittance report')
  }
}
